import * as yup from 'yup';
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import commonFormMeta from '@Shared/components/form/commonFormMeta';

export interface ITransactionsMeta{
  acquirerBank: FormInputMeta;
  transactionCode: FormInputMeta;
  usageCode: FormInputMeta;
  startDate: FormInputMeta;
  endDate: FormInputMeta;
  
  schema: any,
}

const TransactionsMeta: ITransactionsMeta = {} as ITransactionsMeta;

TransactionsMeta.acquirerBank = {
  label: "Banque acquéreur",
  name: "acquirerBank",
  type: 'select',
  options: [
    {
      label: 'bank One',
      value: 'bank1',
      selected: true,
    },
    {
      label: 'bank two',
      value: 'bank2',
    },
  ],
};
TransactionsMeta.transactionCode = commonFormMeta.transactionCode;
TransactionsMeta.usageCode = commonFormMeta.usageCode;
TransactionsMeta.startDate = commonFormMeta.startDate;
TransactionsMeta.endDate = commonFormMeta.endDate;

TransactionsMeta.schema = yup.object().shape(getValidationSchema(TransactionsMeta));

export default TransactionsMeta;

